<script lang="ts" setup>
const { Ctrl_I } = useMagicKeys()

const adminBarEnabled = ref(false)
const adminOpaqueToken = ref('')

watch(Ctrl_I, (pressed) => {
  // Toggle admin bar
  if (adminOpaqueToken.value && pressed) {
    adminBarEnabled.value = !adminBarEnabled.value
  }
})

// Mounted
onMounted(() => {
  adminOpaqueToken.value = localStorage.getItem('adminOpaqueToken') || ''
})
</script>

<template>
  <LayoutAdminBar v-if="adminBarEnabled" />
</template>
